"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordField = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const textfield_helpers_1 = require("@/components/common/input/semantics/textfield.helpers");
require("@/components/common/icon-button/semantics/reveal-button");
require("@/components/common/input/input");
let PasswordField = class PasswordField extends (0, textfield_helpers_1.withTextfieldState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.revealed = false;
    }
    render() {
        return (0, lit_1.html) `
      ${(0, textfield_helpers_1.renderFieldLabel)(this.inputId, this.label, this.optional)}
      <slot name="link"></slot>
      <div class="textfield-control" aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}>
        <mm-input
          input-id=${this.inputId}
          .type=${this.revealed ? 'text' : 'password'}
          .value=${this.value}
          .name=${this.name}
          .placeholder=${this.placeholder}
          aria-label=${this.label ?? this.placeholder ?? lit_1.nothing}
          aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}
          aria-describedby=${this.describedBy || lit_1.nothing}
          @input=${this.handleInput}
        ></mm-input>
        <mm-reveal-button
          .revealed=${this.revealed}
          @toggle=${this.handleRevealToggle}
        ></mm-reveal-button>
      </div>
      ${(0, textfield_helpers_1.renderFieldDescription)(this.description, `${this.inputId}-description`)}
      ${(0, textfield_helpers_1.renderFieldValidation)(`${this.inputId}-validation`, this.validationText)}
    `;
    }
    handleRevealToggle(event) {
        event.stopPropagation();
        this.revealed = event.detail.revealed;
    }
};
PasswordField.styles = input_styles_1.textfieldStyles;
__decorate([
    (0, decorators_js_1.state)()
], PasswordField.prototype, "revealed", void 0);
PasswordField = __decorate([
    (0, decorators_js_1.customElement)('mm-passwordfield')
], PasswordField);
exports.PasswordField = PasswordField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3dvcmRmaWVsZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInBhc3N3b3JkZmllbGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQStDO0FBQy9DLHFEQUF3RDtBQUN4RCxnRUFBd0Q7QUFFeEQseUVBQXdFO0FBQ3hFLDZGQUs4RDtBQUM5RCxtRUFBZ0U7QUFDaEUsMkNBQXdDO0FBR2pDLElBQU0sYUFBYSxHQUFuQixNQUFNLGFBQWMsU0FBUSxJQUFBLHNDQUFrQixFQUFDLGdCQUFVLENBQUM7SUFBMUQ7O1FBRVksYUFBUSxHQUFHLEtBQUssQ0FBQTtJQWdDbkMsQ0FBQztJQTlCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtRQUNQLElBQUEsb0NBQWdCLEVBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxRQUFRLENBQUM7O29EQUViLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsV0FBVyxJQUFJLFNBQVMsQ0FBQzs7cUJBRXZFLElBQUksQ0FBQyxPQUFPO2tCQUNmLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsVUFBVTttQkFDbEMsSUFBSSxDQUFDLEtBQUs7a0JBQ1gsSUFBSSxDQUFDLElBQUk7eUJBQ0YsSUFBSSxDQUFDLFdBQVc7dUJBQ2xCLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLFdBQVcsSUFBSSxhQUFPO3lCQUN2QyxJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDLFdBQVcsSUFBSSxTQUFTLENBQUM7NkJBQ3BDLElBQUksQ0FBQyxXQUFXLElBQUksYUFBTzttQkFDckMsSUFBSSxDQUFDLFdBQVc7OztzQkFHYixJQUFJLENBQUMsUUFBUTtvQkFDZixJQUFJLENBQUMsa0JBQWtCOzs7UUFHbkMsSUFBQSwwQ0FBc0IsRUFBQyxJQUFJLENBQUMsV0FBVyxFQUFFLEdBQUcsSUFBSSxDQUFDLE9BQU8sY0FBYyxDQUFDO1FBQ3ZFLElBQUEseUNBQXFCLEVBQUMsR0FBRyxJQUFJLENBQUMsT0FBTyxhQUFhLEVBQUUsSUFBSSxDQUFDLGNBQWMsQ0FBQztLQUMzRSxDQUFBO0lBQ0gsQ0FBQztJQUVPLGtCQUFrQixDQUFDLEtBQXlDO1FBQ2xFLEtBQUssQ0FBQyxlQUFlLEVBQUUsQ0FBQTtRQUN2QixJQUFJLENBQUMsUUFBUSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFBO0lBQ3ZDLENBQUM7O0FBaENNLG9CQUFNLEdBQUcsOEJBQWUsQ0FBQTtBQUN0QjtJQUFSLElBQUEscUJBQUssR0FBRTsrQ0FBeUI7QUFGdEIsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsa0JBQWtCLENBQUM7R0FDckIsYUFBYSxDQWtDekI7QUFsQ1ksc0NBQWEifQ==